import { useState } from 'react'
import { Fold } from './Fold'
import type { ConversationMessage } from '../types'

/**
 * The thread exactly as the backend read it.
 *
 * Deliberately not cosmetic: when a draft looks wrong the first question is
 * whether the model saw the conversation at all, and without this a bad draft
 * and a blind one are indistinguishable.
 */
export function ConversationView({ messages }: { messages: ConversationMessage[] }) {
  const [all, setAll] = useState(false)

  if (!messages.length) {
    return (
      <Fold title="Conversation read" count="nothing read">
        <p className="note">Nothing was read from this ticket.</p>
      </Fold>
    )
  }

  const shown = all ? messages : messages.slice(-3)

  return (
    <Fold title="Conversation read" count={`${messages.length} messages`}>
      <ul className="thread">
        {shown.map((m) => (
          <li key={m.id}>
            <span className={`who ${m.direction === 'out' ? 'agent' : 'customer'}`}>
              {m.direction === 'out' ? 'Agent' : 'Customer'}
              {m.author ? ` · ${m.author}` : ''}
            </span>
            <p>{m.content}</p>
          </li>
        ))}
      </ul>

      {messages.length > 3 && (
        <button className="linkish" onClick={() => setAll(!all)}>
          {all ? 'Show fewer' : `Show all ${messages.length}`}
        </button>
      )}
    </Fold>
  )
}
